/**
 * Created by OBL on 14/01/2016.
 */
define('adminLmbAnasController',[
    'module',
    'underscore',
    'app',
    'adminLmbAnasView',
    'bootbox',
    'lmbAnaCreateEditLayoutView',
    'settings',
    'entities/lmbanas'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var AdminLmbAnaListController = {
        showLmbAnaList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'lmbana:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showLmbAnaAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                lmbAnaModel: App.request('lmbana:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('lmbana.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('lmbana:get-collection-url'),
                rowCountUrl: App.request('lmbana:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('lmbana.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('lmbana:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = AdminLmbAnaListController;
});
